if(!$('#simple-variants').length){
    if($('.variant-list').length>0){
        $('.variant-list select[data-parameter-name="Velikost"]').each(function(){
            if($(this).closest('.variant-list').find('th .show-tooltip').length){
                var listTootip = $(this).closest('.variant-list').find('th .show-tooltip').attr('title')
            }
            else{
                listTootip = ''
            }
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                    if ($.isNumeric($(this).val())) {
                        var textsplit = $(this).text().split('+')
                        html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                        html_var += '<div class="text">'
                        if(typeof textsplit[1] === 'undefined'){
                            html_var += textsplit[0]
                        }
                        else{
                            html_var += textsplit[0]+' (+'+textsplit[1]+')'
                        }
                        
                        if(listTootip !== ''){
                            if(textsplit[1] !== '0 Kč'){
                                html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                            }
                        }
                        html_var += '</div>'
                        html_var += '</div>'
                    }
                }
                else{
                    if ($.isNumeric($(this).val())) {
                        var textsplit = $(this).text().split('+')
                        html_var += '<div class="variant show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                        html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                        html_var += '</div>'
                    }
                }
                
            })
            html_var += '</div>'
            html_var += '</div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
            $(this).closest('.variant-list span').hide()
            
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
            
            }
        }
        
    }
}
    

$(document).on('click', '.custom-variant-wrap .variant', function(){
    const variantData = $(this).data('value');
    const variantParameterId = $(this).data('parameter-id');
        $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
            return $(this).attr('value') == variantData;
        }).change().prop("selected", true);
        $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
        $(this).addClass("active"); 
    

    var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');

    $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));

    $('.custom-variant-wrap .variant').each(function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
        const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
        if (unavailable === true) {
            $(this).addClass("unavailable").removeClass("active");
        }
        else{
            $(this).removeClass("unavailable");
        } 
    });
});

$(document).on('click', '#jsUnavailableCombinationMessage a', function(){
    $('.custom-variant-wrap .variant').removeClass('unavailable')
})
$(document).ready(function(){
    $(".custom-variant-wrap").each(function() {
        var $variants = $(this).find("div.variant");
        if ($variants.length === 1) {
            $variants.addClass("active");
        }
        });
    var urlParams = new URLSearchParams(window.location.search);
    var parameterValueId = urlParams.get("parameterValueId");
    var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
    if ($divToHighlight.length > 0) {
        $divToHighlight.addClass("active");
    }
})